import { useState } from 'react';
import { Container, Row, Col, Modal, Button } from 'react-bootstrap';
import "bootstrap-icons/font/bootstrap-icons.css";

const Footer = () => {
  const [modalContent, setModalContent] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [showModal, setShowModal] = useState(false);

  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setShowModal(true);
  };

  return (
    <footer style={{ backgroundColor: 'var(--color-header-footer)', color: 'white' }} className="py-5 mt-5">
      <Container>
        <Row>
          <Col md={6}>
            <h5>Horario de Atención</h5>
            <p className="mb-0">Martes a Viernes: 11:00 am - 8:00 pm</p>
            <p>Sábado y Domingo: 11:00 am - 6:00 pm</p>
            <p className="mt-4 mb-1" style={{ fontSize: '0.85rem', fontFamily: 'Inter, sans-serif' }}>
              <strong>Dirección:</strong> San José, Costa Rica
            </p>
            <p className="mb-0" style={{ fontSize: '0.85rem', fontFamily: 'Inter, sans-serif' }}>
              <strong>Contacto:</strong> soporte@arzuweb.com | Tel: +506 8888-8888
            </p>
          </Col>

          <Col md={6} className="text-md-end">
            <h5>Síguenos en nuestras redes</h5>
            <div className="d-flex gap-3 justify-content-md-end mb-3">
              <a href="https://instagram.com/tu_perfil" target="_blank" rel="noopener noreferrer" className="text-light">
                <i className="bi bi-instagram fs-4"></i>
              </a>
              <a href="https://facebook.com/tu_perfil" target="_blank" rel="noopener noreferrer" className="text-light">
                <i className="bi bi-facebook fs-4"></i>
              </a>
              <a href="https://wa.me/tunumero" target="_blank" rel="noopener noreferrer" className="text-light">
                <i className="bi bi-whatsapp fs-4"></i>
              </a>
              <a href="https://tiktok.com/@tu_perfil" target="_blank" rel="noopener noreferrer" className="text-light">
                <i className="bi bi-tiktok fs-4"></i>
              </a>
            </div>

            {/* Botones legales */}
            <div className="d-flex flex-wrap justify-content-md-end gap-2 mt-3">
              <Button size="sm" variant="outline-light" onClick={() => openModal('Política de Reembolsos', 'Todas las compras son finales. Solo se aceptan devoluciones en caso de error de cobro o defecto comprobado del producto.')}>Reembolsos</Button>
              <Button size="sm" variant="outline-light" onClick={() => openModal('Política de Privacidad', 'La información personal se maneja con confidencialidad y se usa exclusivamente para procesar pedidos, contacto y soporte.')}>Privacidad</Button>
              <Button size="sm" variant="outline-light" onClick={() => openModal('Términos y Condiciones', 'Al utilizar este sitio aceptás nuestras condiciones de servicio y políticas de compra publicadas.')}>Términos</Button>
              <Button size="sm" variant="outline-light" onClick={() => openModal('Seguridad', 'Este sitio utiliza conexiones seguras (HTTPS) y procesadores de pago certificados. Los datos de tu tarjeta no se almacenan.')}>Seguridad</Button>
              <Button size="sm" variant="outline-light" onClick={() => openModal('Política de Entrega', 'Los productos pueden ser retirados en tienda o enviados por mensajería dentro de Costa Rica. Tiempo estimado de entrega: 1-3 días hábiles.')}>Entrega</Button>
            </div>
          </Col>
        </Row>

        <Row className="mt-4 justify-content-center text-center">
          <p className="text-light mb-2">Pagos protegidos con:</p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <img src="/assets/verified-by-visa.png" alt="Verified by Visa" style={{ height: '35px' }} />
            <img src="/assets/securecode.png" alt="MasterCard SecureCode" style={{ height: '35px' }} />
          </div>
        </Row>

        <hr className="my-4" />
        <p className="text-center mb-0 small">
          © 2024 Arzú Store - Todos los derechos reservados
        </p>
      </Container>

      {/* Modal legal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: '0.9rem', fontFamily: 'Inter, sans-serif' }}>
          {modalContent}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </footer>
  );
};

export default Footer;
